module.exports = __webpack_public_path__ + "img/chateaubriand.974a7a2f.jpg";